module.exports = __webpack_public_path__ + "img/person-doc.b82e4fd2.png";